import { __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import clsx from 'clsx';
import ReactCanvasConfetti from 'react-canvas-confetti';
import { FormProvider } from 'react-hook-form';
import ImportElements from '../Import/ImportElements/index.js';
import ImportIndexing from '../Import/ImportIndexing/index.js';
import ImportSuccess from '../Import/ImportSuccess/index.js';
import ImportUpload from '../Import/ImportUpload/index.js';
import KModalImport from '../KModalImport/index.js';
import KModalImportHeader from '../KModalImport/KModalImportHeader/index.js';
import { KModalImportMode } from '../KModalImport/types.js';
import { useKFImport } from './hooks.js';

var KFImport = function (_a) {
    var open = _a.open, onClose = _a.onClose, userEmail = _a.userEmail, internalFieldNames = _a.internalFieldNames, formTypeFormIdMappings = _a.formTypeFormIdMappings, uploadKey = _a.uploadKey, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KFImport" : _b, sx = _a.sx, overrideClassificationStep = _a.overrideClassificationStep, indexInAllAvailableLocale = _a.indexInAllAvailableLocale, classificationDestination = _a.classificationDestination, KIcon = _a.KIcon;
    var _c = useState(KModalImportMode.Upload), mode = _c[0], setMode = _c[1];
    var _d = useKFImport({
        internalFieldNames: internalFieldNames,
        formTypeFormIdMappings: formTypeFormIdMappings,
        uploadKey: uploadKey,
        overrideClassificationStep: overrideClassificationStep,
        indexInAllAvailableLocale: indexInAllAvailableLocale,
        classificationDestination: classificationDestination
    }), formFields = _d.formFields, processIndexation = _d.processIndexation, kpkMediaImports = _d.kpkMediaImports, isIndexationFinished = _d.isIndexationFinished, isIndexationInProgress = _d.isIndexationInProgress, isUploadFinished = _d.isUploadFinished, isIndexationInError = _d.isIndexationInError, reset = _d.reset, reactHookFormMethods = _d.reactHookFormMethods;
    useEffect(function () {
        if (isIndexationFinished) {
            setMode(KModalImportMode.Success);
        }
        else if (kpkMediaImports.length > 0) {
            setMode(KModalImportMode.Indexing);
        }
    }, [kpkMediaImports.length, isIndexationFinished]);
    var handleOnClose = function () {
        onClose();
        reset();
        setMode(KModalImportMode.Upload);
    };
    var handleOnCancel = function () {
        onClose();
        reset();
        setMode(KModalImportMode.Upload);
    };
    var handleOnBackground = function () {
        onClose();
    };
    var handleOnSaveAndQuit = function () {
        onClose();
    };
    var _e = useState(false), fire = _e[0], setFire = _e[1];
    useEffect(function () {
        if (mode === KModalImportMode.Success) {
            setFire(true);
        }
    }, [mode]);
    return (React__default.createElement(KModalImport, { open: open, uploadKey: uploadKey, header: React__default.createElement(KModalImportHeader, { mode: mode, uploading: false, onBackground: handleOnBackground, onCancel: handleOnCancel, onClose: handleOnClose, onSaveAndQuit: handleOnSaveAndQuit, KIcon: KIcon }), mode: mode, kgrid: React__default.createElement(ImportElements, { uploadKey: uploadKey, elements: kpkMediaImports, KIcon: KIcon }), className: clsx("KFImport", className), "data-testid": testId, style: {
            position: "relative"
        }, sx: sx },
        React__default.createElement(ReactCanvasConfetti, { "data-testid": "KFImport-confetti", style: {
                position: "absolute",
                zIndex: "1",
                width: "100%",
                height: "100%",
                display: fire ? "initial" : "none",
                pointerEvents: "none",
                top: 0,
                left: 0
            }, particleCount: 200, origin: { y: 0.5 }, spread: 360, fire: fire, onDecay: function () { return setFire(false); } }),
        mode === KModalImportMode.Upload && (React__default.createElement(ImportUpload, { onCancel: handleOnCancel, uploadKey: uploadKey, KIcon: KIcon })),
        mode === KModalImportMode.Indexing && (React__default.createElement(FormProvider, __assign({}, reactHookFormMethods),
            React__default.createElement(ImportIndexing, { elements: kpkMediaImports, onCancel: handleOnCancel, onSendAssets: processIndexation, fields: formFields, loading: !isIndexationInError && (isIndexationInProgress || !isUploadFinished), uploadKey: uploadKey, KIcon: KIcon }))),
        mode === KModalImportMode.Success && (React__default.createElement(ImportSuccess, { elements: kpkMediaImports, email: userEmail, onClose: handleOnClose, KIcon: KIcon }))));
};

export { KFImport as default };
//# sourceMappingURL=index.js.map
